/* ==================================================
  preorder-cart-guard
  予約商品と通常商品がカートに混在した場合の制御。
  - チェックアウトボタンを無効化（同時購入を防止）
  - 動的チェックアウトボタンを非表示
  - 注意ポップアップの表示（カートページ／カートドロワー）

  予約商品かどうかは Liquid が各カート行に付与する data-preorder="true"
  （販売元 PRE ORDER）で判定する。
  カートDOMの変化を MutationObserver で監視し、AJAX 更新（数量変更・削除・
  商品追加）に追従してボタン状態・注意文・ポップアップを更新する。

  ポップアップの表示タイミング:
  - カートページ（/cart）: 読み込み時／数量変更で混在になった時に自動表示
  - カートドロワー: ドロワーが開いた時に混在していれば表示（閉じると閉じる）
===================================================*/

(function () {
  'use strict';

  /*  スクリプトが複数セクションから読み込まれても初期化は1回だけ  */
  if (window.__preorderCartGuardInit) return;
  window.__preorderCartGuardInit = true;

  /* ------------------------------
    混在判定（DOMのカート行から）
  ------------------------------*/

  /*  予約行（data-preorder="true"）と通常行が両方存在すれば混在  */
  function computeMixed() {
    var rows = document.querySelectorAll('.cart-item');
    var hasPreorder = false;
    var hasNormal = false;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-preorder') === 'true') {
        hasPreorder = true;
      } else {
        hasNormal = true;
      }
      if (hasPreorder && hasNormal) return true;
    }
    return false;
  }

  /*  カートページ（/cart）表示中かどうか  */
  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  /* ------------------------------
    ポップアップ開閉
  ------------------------------*/

  /*  ユーザーが手動で閉じたか
      ドロワー操作（数量変更・追加）で class が付け替わるたびに再表示されると
      「閉じられない」状態になるため、閉じたら再表示を抑止する。
      ドロワーを閉じ直す／混在が解消した時にリセットする。  */
  var userDismissed = false;

  function openPopups() {
    document.querySelectorAll('[data-preorder-mixed-popup]').forEach(function (popup) {
      popup.classList.add('is-active');
    });
  }

  function closePopups() {
    document.querySelectorAll('[data-preorder-mixed-popup]').forEach(function (popup) {
      popup.classList.remove('is-active');
    });
  }

  /*  ユーザー操作による明示的な閉じる（再表示を抑止）  */
  function dismissPopups() {
    userDismissed = true;
    closePopups();
  }

  /* ------------------------------
    チェックアウト系の制御反映
  ------------------------------*/

  function toggleControls(mixed) {
    /*  チェックアウトボタンの有効・無効  */
    document.querySelectorAll('[data-preorder-checkout]').forEach(function (btn) {
      btn.disabled = mixed;
      btn.setAttribute('aria-disabled', mixed ? 'true' : 'false');
    });

    /*  動的チェックアウト（Shop Pay 等）の表示・非表示  */
    document.querySelectorAll('[data-preorder-dynamic-checkout]').forEach(function (el) {
      el.classList.toggle('preorder-hidden', mixed);
    });

    /*  チェックアウト不可の注意文の表示・非表示  */
    document.querySelectorAll('[data-preorder-blocked-note]').forEach(function (el) {
      el.classList.toggle('preorder-hidden', !mixed);
    });
  }

  /* ------------------------------
    状態評価
  ------------------------------*/

  /*  直近の混在状態（false→true の遷移検知用）  */
  var wasMixed = false;

  function evaluate() {
    var mixed = computeMixed();
    toggleControls(mixed);

    if (!mixed) {
      /*  混在解消時は必ず閉じ、閉じる抑止フラグもリセット  */
      userDismissed = false;
      closePopups();
    } else if (!wasMixed && isCartPage()) {
      /*  カートページで混在に切り替わった瞬間のみ自動表示  */
      userDismissed = false;
      openPopups();
    }

    wasMixed = mixed;
  }

  /* ------------------------------
    初期化
  ------------------------------*/

  function init() {
    /*  初期状態を反映（カートページで既に混在なら自動表示）  */
    evaluate();

    /*  閉じる操作（イベント委譲）
        - 閉じるボタン（[data-preorder-popup-close]）
        - ダイアログ本体（.preorder-mixed-popup__dialog）以外の領域クリック  */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-preorder-popup-close]')) {
        dismissPopups();
        return;
      }
      var popup = event.target.closest('[data-preorder-mixed-popup]');
      if (popup && !event.target.closest('.preorder-mixed-popup__dialog')) {
        dismissPopups();
      }
    });

    /*  Esc キーで閉じる  */
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') dismissPopups();
    });

    var mainCart = document.getElementById('main-cart-items');
    var drawer = document.querySelector('cart-drawer');

    /*  カートDOMの変化（AJAX 再描画）を監視して再評価  */
    if ('MutationObserver' in window) {
      var scheduled = false;
      var contentObserver = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          evaluate();
        });
      });
      if (mainCart) contentObserver.observe(mainCart, { childList: true, subtree: true });
      if (drawer) contentObserver.observe(drawer, { childList: true, subtree: true });

      /*  ドロワーの開閉（active クラス）に追従
          開いた時に混在していればポップアップ表示、閉じたら閉じる  */
      if (drawer) {
        var drawerObserver = new MutationObserver(function () {
          if (drawer.classList.contains('active')) {
            /*  ドロワーが開いている間はユーザーが閉じたら再表示しない  */
            if (computeMixed() && !userDismissed) openPopups();
          } else {
            /*  ドロワーを閉じたら抑止フラグをリセット（次回開いたら再度表示）  */
            userDismissed = false;
            closePopups();
          }
        });
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
